type Props = {
	firstName: string | null | undefined;
	middleName?: string | null;
	lastName: string | null | undefined;
	shortMiddleName?: boolean;
	suffix?: string | null;
	prefix?: string | null;
	nickname?: string | null;
};

export const getHcpDisplayName = ({
	firstName,
	middleName,
	lastName,
	suffix,
	prefix,
	shortMiddleName = false,
	nickname
}: Props): string => {
	if (!firstName || !lastName) {
		return '';
	}

	const parts = [
		prefix?.trim(),
		firstName.trim(),
		nickname && `(${nickname?.trim()})`,
		shortMiddleName && middleName
			? `${middleName.trim().charAt(0)}.`
			: middleName?.trim(),
		lastName.trim(),
		suffix?.trim()
	];

	return parts.filter(Boolean).join(' ');
};
